import React from 'react';
import PortfolioGrid from '../components/sections/PortfolioGrid';
import Banner4 from '../components/sections/Banner4';

const Portfolio = () => {
  return (
    <main className="bg-black min-h-screen">
      <div className="md:pt-32 pt-12">
        <PortfolioGrid />
      </div>
      <Banner4 />
    </main>
  );
};

export default Portfolio;
